import { Sprite, Texture } from 'pixi.js';
import Button from './Button';
import { Easing, Tween } from '@tweenjs/tween.js';
import HELPERS from '../lib/globals/helpers/Helpers';

class ToggleButtonNew extends Button {
	constructor(obj) {
		super(obj);
		this.active = false;
		this.obj = obj;

		this.holder = new Sprite();
		this.holder.sortableChildren = true;
		this.addChild(this.holder);
		if (obj.bg) {
			this.bg = Sprite.from(Texture.from(obj.bg));
			this.holder.addChild(this.bg);
			this.bg.anchor.set(0.5);
			this.bg.x = 0;
			this.bg.y = 0;
			this.bg.zIndex = 2;
		}
		if (obj.icon) {
			this.icon = Sprite.from(Texture.from(obj.icon));
			this.holder.addChild(this.icon);
			this.icon.anchor.set(0.5);
			this.icon.x = this.holder.width / 2;
			this.icon.y = this.holder.height / 2;
			this.icon.zIndex = 3;
		}
		if (obj.animation) {
			this.animation = HELPERS.getAnimatedSprite(obj.animation);
			this.animation.eventMode = 'none';
			this.animation.anchor.set(0.5);
			this.animation.scale.set(0.7);
			this.animation.position.x = this.holder.width / 2;
			this.animation.position.y = -50;
			this.holder.addChild(this.animation);
			this.animation.zIndex = 1;
		}
	}

	mouseUpHandler() {
		if (this.bg) {
			this.tweener = new Tween(this.bg.scale)
				.to({ x: 1, y: 1 }, 150)
				.easing(Easing.Linear.None)
				.start();
			this.tweenBg2 = new Tween(this.bg)
				.to({ rotation: 0 }, 150)
				.easing(Easing.Linear.None)
				.start();
		}
		if (this.icon) {
			this.tweenIcon = new Tween(this.icon.scale)
				.to({ x: 1, y: 1 }, 150)
				.easing(Easing.Linear.None)
				.start();
			this.tweenIcon2 = new Tween(this.icon)
				.to({ rotation: 0 }, 100)
				.easing(Easing.Linear.None)
				.start();
		}
		if (this.animation) {
			this.animation.visible = false;
			this.tweenAnimation = new Tween(this.animation.scale)
				.to({ x: 0, y: 0 }, 150)
				.easing(Easing.Linear.None)
				.start();
			this.animation.gotoAndStop(0);
		}
	}
	mouseDownHandler() {
		if (this.bg) {
			this.tweenBg = new Tween(this.bg.scale)
				.to({ x: 0.9, y: 0.9 }, 150)
				.easing(Easing.Linear.None)
				.start();
			this.tweenBg2 = new Tween(this.bg)
				.to({ rotation: 3.14 }, 150)
				.easing(Easing.Linear.None)
				.start();
		}
		if (this.icon) {
			this.tweenIcon = new Tween(this.icon.scale)
				.to({ x: 0.9, y: 0.9 }, 150)
				.easing(Easing.Linear.None)
				.start();
			this.tweenIcon2 = new Tween(this.icon)
				.to({ rotation: 6.28 }, 100)
				.easing(Easing.Linear.None)
				.start();
		}
		if (this.animation) {
			this.animation.visible = true;
			this.animation.gotoAndPlay(0);
			this.tweenAnimation = new Tween(this.animation.scale)
				.to({ x: 0.7, y: 0.7 }, 150)
				.easing(Easing.Linear.None)
				.start();
		}
	}

	clickHandler(e) {
		window.sm.play({ name: 'press_click_sfx' });
		this.active = !this.active;
		super.clickHandler(e);
		// if (this.obj.press) {
		//   if (this.active) {
		//     super.pressDown()
		//   } else {
		//     super.pressUp()
		//   }
		// } else {
		if (this.active) {
			this.mouseDownHandler(e);
		} else {
			this.mouseUpHandler(e);
		}
		// }
	}
	//   mouseupoutsideHandler(e) {
	//     if (this.active) {
	//       this.mouseDownHandler(e);
	//     } else {
	//       super.mouseUpHandler(e);
	//     }
	//   }
	setActive(active) {
		this.active = active;
		if (active) {
			this.mouseDownHandler();
		} else {
			this.mouseUpHandler();
		}
	}

	getSize() {
		return {
			width: this.bg.width,
			height: this.bg.height
		};
	}
}

export default ToggleButtonNew;
